import { markRaw } from 'vue'
import { DEFAULT_COLOR_PRIMARY } from '../constants'
import TabsView from './TabsView.vue'
import schema from './schema'
import uiSchema from './ui-schema'

export default {
  viewComponent: markRaw(TabsView),
  editorSchema: schema,
  editorUISchema: uiSchema,
  editorData: {
    activeTabButtonColor: DEFAULT_COLOR_PRIMARY,
    activeTabTextColor: '#ffffff',
    tabs: [
      {
        label: 'Vestibulum vehicula',
        text: 'Aliquam justo est, scelerisque non faucibus quis, suscipit ac arcu. Integer quis convallis risus. Proin rutrum neque a leo tincidunt, eu sagittis mi scelerisque. Maecenas id libero nec nibh accumsan tempus eu tristique erat. Nunc feugiat pulvinar consectetur. Ut a tincidunt neque. Etiam blandit venenatis nunc, tincidunt ultricies est auctor a. In suscipit nec nisl vel mollis. In at dui quam.',
        image: 'https://cdn.wnhub.io/39338/65e0a4359cd456.64812459.svg',
        imageWidth: 'w-1/3',
      },
      {
        label: 'Proceeding with paperwork',
        text: 'The customer fills out a detailed recruitment application and describes the project and the vacancy in as much detail as possible. We sign the contract and applications.',
      },
      {
        label: 'Сlarifying the details',
        text: 'We meet with a client to exchange the information and clarify the details. We decide on the dates, stages, and areas of responsibility to start working together.',
      },
      {
        label: 'Posting the vacancies',
        text: 'We post vacancies on specialized sites. We make sure our postings offer a detailed high-quality description of the vacancy, project, team, and specific tasks to attract the right candidate.',
      },
      {
        label: 'Conducting job interviews',
        text: "We conduct video interviews with candidates interested in the client's proposal, and find out everything about candidates' current and previous work experience, tech knowledge, motivation, etc.",
      },
    ],
  },
}
